export default __webpack_public_path__ + "static/media/operadorCC1.55b47848.jpg";